import { ResourceDescriptor } from "./common";

// this is probably deprecated as we do not use the schema for the reset password form
const reset_password: ResourceDescriptor = {
    url: "reset_password",
    orders: {
        create: ["password", "retype_password"],
    },
    crudActions: ["create"],
    resourceSchemaPostProcessor: (schema) => {
        schema["retype_password"] = {
            default: null,
            required: false,
            type: {
                name: "String",
            },
            name: "retype_password",
            validators: [
                {
                    params: { passwordFieldName: "password" },
                    name: "passwordMatch",
                    key: "passwordMatch_error",
                },
            ],
        };
    },
};

export default reset_password;
